module.exports = __webpack_public_path__ + "fonts/7dd15d9a51df032c19cc131e004d9e80.svg";